import { useMatch } from "react-router-dom"
import { RecentFoodsTabBtn } from "./styled"
import PATHS from "router/paths"
import { FlexBox } from "components/Common/FlexBox"
import { useMealTypeQueryParams } from "features/meal/hooks"

const TopNavigation = () => {
  const mealTypeQueryParams = useMealTypeQueryParams()
  const isRecipesPage = useMatch(PATHS.app.myFoods.recipes)
  const isSchedulePage = useMatch(PATHS.app.myFoods.schedules)
  const isFavoritePage = useMatch(PATHS.app.myFoods.root)

  return (
    <FlexBox
      $gap={12}
      $justify="flex-start"
      style={{ padding: "6px var(--app-horizontal-padding)" }}
    >
      <RecentFoodsTabBtn
        $isActive={!!isFavoritePage}
        to={`${PATHS.app.myFoods.root}${mealTypeQueryParams}`}
      >
        Favorites
      </RecentFoodsTabBtn>

      <RecentFoodsTabBtn
        $isActive={!!isRecipesPage}
        to={`${PATHS.app.myFoods.recipes}${mealTypeQueryParams}`}
      >
        Recipes
      </RecentFoodsTabBtn>
      <RecentFoodsTabBtn
        $isActive={!!isSchedulePage}
        to={`${PATHS.app.myFoods.schedules}${mealTypeQueryParams}`}
      >
        Scheduled
      </RecentFoodsTabBtn>
    </FlexBox>
  )
}

export default TopNavigation
